import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import word_counter from "../../images/apps/word_counter.png";
import my_ip from "../../images/apps/my_ip.png";
import tic_tac_toe from "../../images/games/tic_tac_toe.png";
import {routes} from "../constants/routes";

export const initialState = {
    apps: [
        { id: 'word-counter', icon: word_counter, link: routes.wordCounter, title: 'Word Counter', description: 'Analyze your text', likes: 0 },
        { id: 'my-ip', icon: my_ip, link: routes.myIP, title: 'My IP', description: 'Get your IP address', likes: 0 }
    ],
    games: [
        { id: 'tic-tac-toe', icon: tic_tac_toe, link: routes.ticTacToe, title: 'Tic-Tac-Toe', description: 'Play with friends', likes: 0 }
    ],
    trendingApps: ['word-counter', 'my-ip'],
    trendingGames: ['tic-tac-toe'],
    favorites: []
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        // addItem: (state, action: PayloadAction<any>) => {
        //     let matched = false;
        //
        //     state.favorites.forEach((item, index) => {
        //         if (item.id !== action.payload.id) {
        //             state.favorites[index] = { ...item };
        //             matched = true;
        //         }
        //     });
        //
        //     if (!matched) {
        //         state.favorites.push(action.payload.id);
        //     }
        // },
        // removeItem: (state, action) => {
        //     state.favorites.forEach((item, index) => {
        //         if (item.id === action.payload.id) {
        //             if (item.amount === 1) {
        //                 state.favorites.splice(index, 1);
        //             } else {
        //                 state.favorites[index] = { ...item, amount: item.amount - 1 };
        //             }
        //         }
        //     });
        // },
    },
    selectors: {
        selectApps: (state) => state.apps,
        selectGames: (state) => state.games,
        selectTrendingApps: (state) => state.trendingApps,
        selectTrendingGames: (state) => state.trendingGames,
    }
});

// export const { addItem, removeItem } = appSlice.actions;
export const { selectApps, selectGames, selectTrendingApps, selectTrendingGames } = appSlice.selectors;